import * as z from 'zod'

import { api } from '../../utils/api'
import { LinkTypes } from '../../models'

const InputSchema = z.tuple([z.object({
	link: z.string().nonempty()
})])

const OutputSchema = z.promise(z.object({
	type: z.nativeEnum(LinkTypes),
	value: z.string()
}).nullable())

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const GetLinkTarget = FunctionSchema.implement(async ({ link }) => await api.get(`/link/${link}/getTarget`))